<template>
	<div style="position: relative;width: 100%;" :style="{...getImgStyle(selectdItem)}">
		<div style="padding: 6px;font-size: 16px;" v-if="selectdItem.compontChildren[0].data.imgUrl.list[0].url == ''  && type == 'design'">
			请添加图片
		</div>
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100vh;height: 100vh;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div :style="{...getImgStyle(selectdItem)}" style="width: 100%;"
			v-if="selectdItem.compontChildren[0].data.imgUrl.list[0].url != ''">
			<img style="max-width: 100%;cursor: pointer;"
				:style="{...getImgStyle(selectdItem),objectFit:getObjectFit(selectdItem)}" @click="hrefNavTo(item)"
				v-for="(item,index) in selectdItem.compontChildren[0].data.imgUrl.list" :key="index" :src="item.url" />
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex';
	import {
		getUrl_name 
	} from '../../api/all.js'
	export default {
		//  数据获取从 vuex 获取
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				loading:false
			}
		},
		computed: {},
		mounted() {
			console.log('mounted selectdItem', this.selectdItem)
		},
		methods: {
			getObjectFit(e) {
				if (e.preStyle.compontentStyle.needHW && this.equipment == 'pc') {
					if (e.preStyle.compontentStyle.percentWidthSwitch) {
						return 'cover'
					} else {
						return 'contain'
					}

				}
				if (e.preStyle.compontentStylePhone.needHW && this.equipment == 'phone') {
					if (e.preStyle.compontentStylePhone.percentWidthSwitch) {
						return 'cover'
					} else {
						return 'contain'
					}
				}
			},
			getImgStyle(e) {
				console.log('getChildConentStyle e', e)
				// 文字渐变
				let style = {}
				if (e.preStyle.compontentStyle.needHW && this.equipment == 'pc') {
					if (e.preStyle.compontentStyle.percentWidthSwitch) {
						// style.width = '100%'
						style.width = e.preStyle.compontentStyle.width + 'px'
					} else {
						style.width = e.preStyle.compontentStyle.width + 'px'
					}
					style.height = e.preStyle.compontentStyle.height + 'px'
				}
				if (e.preStyle.compontentStylePhone.needHW && this.equipment == 'phone') {
					if (e.preStyle.compontentStylePhone.percentWidthSwitch) {
						// style.width = '100%'
						style.width = e.preStyle.compontentStylePhone.width + 'px'
					} else {
						style.width = e.preStyle.compontentStylePhone.width + 'px'
					}
					style.height = e.preStyle.compontentStylePhone.height + 'px'
				}
				console.log('getChildConentStyleegetImgStyle', style)
				return style
			},
			async hrefNavTo(item) {
				console.log('hrefNavTo', item)
				if(this.type == 'design') {
					return
				}
				if(!item.link){
					return
				}
				
				if(item.link.cacheLinkIndex == '首页') {
					this.$router.push({
						path: '/'
					})
					return
				}
				
				if(item.link.cacheLinkIndex == '热销商品') {
					this.$router.push({
						path: '/categories_products/hot'
					})
					this.show = false
					return
				}
				if(item.link.cacheLinkIndex == '最新商品') {
					this.$router.push({
						path: '/categories_products/new'
					})
					this.show = false
					return
				}
				
				if(item.link.cacheLinkIndex == '浏览最多') {
					this.$router.push({
						path: '/categories_products/visit'
					})
					this.show = false
					return
				}
				if(item.link.cacheLinkIndex == '所有商品') {
					this.$router.push({
						path: '/categories_products/all'
					})
					this.show = false
					return
				}
				
				
				if(item.link.cacheLinkIndex == '商品分类') {
					try{
						this.loading = true
						const urlData = await getUrl_name({
							type:"categories",
							id:item.link.link.id
						})
						this.$router.push({
							path: '/categories/' + urlData.data.data
						})
						this.loading = false
					}catch(e) {
						this.loading = false
					}
					return
				}
				
				
				

				let url = item.link.link.url
				if (item.link.link.type == '站内链接') {

				}
				if (item.link.link.type == "外部链接") {
					window.open(item.link.link.name);
					return
				}

				if (item.link.link.type == '站内链接') {
					// 判断是否是站内链接
					console.log('item.link', item.link)
					console.log(window.location.host)
					if (item.link.link.name.indexOf(window.location.host) != -1) {
						let arr = item.link.link.name.split(window.location.host)
						this.$router.push({
							path: arr[1],
						})
						return
					} else {
						window.open(item.link.link.name);
						return 
					}
				}
				if(url) {
					this.$router.push({
						path: '/' + url,
					})
				}
			},
		}
	}
</script>

<style>
</style>